import React from 'react';
import { Text, Colors } from 'library';
import { Grid, useMediaQuery } from '@mui/material';
import TheTandemSolutionStepper from '../on-demand/TheTandemSolutionStepper';
import theme from 'theme';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Helping from 'assets/images/eldercare/helping.png';

export default function EldercareSolution() {
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const variant = smDown ? 'body1' : 'h2';

    const styles = {
        solution: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: smDown ? Colors.mediumTurq : Colors.turquoise,
            height: 50,
            width: 240,
            padding: 20,
            paddingRight: 10,
            borderRadius: 40,
            alignSelf: 'end',
        },
        chevron: {
            backgroundColor: smDown ? Colors.darkNavy : Colors.white,
            width: 36,
            height: 36,
            borderRadius: 25,
            display: 'flex',
            alignItems: 'ceneter',
            justifyContent: 'center',
        },
    };

    const steps = [
        {
            key: 'worker',
            label: (
                <Text variant={variant} bold>
                    Qualified{' '}
                    <Text variant={variant} inline bold color={Colors.turquoise}>
                        STNA{' '}
                    </Text>
                    looking for work.
                </Text>
            ),
        },
        {
            key: 'tandem',
            label: (
                <Text variant={variant} bold color={Colors.turquoise}>
                    Tandem{' '}
                    <Text variant={variant} inline bold>
                        facilitates the match.
                    </Text>
                </Text>
            ),
        },
        {
            key: 'business',
            label: (
                <Text variant={variant} bold color={Colors.turquoise}>
                    Senior Care Facility{' '}
                    <Text variant={variant} inline bold>
                        looking for staff.
                    </Text>
                </Text>
            ),
        },
    ];
    return (
        <Grid
            xs={12}
            style={{ gap: 20, backgroundColor: Colors.white, padding: smDown ? 20 : 50 }}
            container
            item
            justifyContent="center"
        >
            <Grid xs={12} lg={5} item container justifyContent="center" alignContent={'center'}>
                <img src={Helping} alt="eldercare-helping" height={400} style={{ alignSelf: 'center' }} />
            </Grid>
            <Grid xs={12} lg={5} item container justifyContent="center" style={{ gap: 20 }}>
                <Grid item style={styles.solution as React.CSSProperties}>
                    <Text variant="h2" bold color={smDown ? Colors.darkNavy : Colors.white}>
                        Our Solution
                    </Text>
                    <div style={styles.chevron}>
                        <KeyboardArrowDownIcon
                            htmlColor={smDown ? Colors.mediumTurq : Colors.turquoise}
                            fontSize="large"
                        />
                    </div>
                </Grid>
                <TheTandemSolutionStepper
                    smDown={smDown}
                    steps={steps}
                    stepperStyles={{ width: '100%', marginLeft: 0, marginTop: 0 }}
                />
            </Grid>
        </Grid>
    );
}
